module.exports = __webpack_public_path__ + "static/3dgence-printer-industry-d0bd14d4e99d424f87edc0006437fc3b.png";